import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, Star, Thermometer, Zap, Wind, ArrowRight, Phone, ShieldCheck, Droplet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious
} from "@/components/ui/carousel";
import AppointmentScheduler from "@/components/AppointmentScheduler";

const logoUrl = "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773774928/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773774928678.png";

const Home = () => {
  const reviews =[
    {
      author: "Rish B",
      subtitle: "een maand geleden",
      text: "Spiro heeft nog net voor de kerst airco’s bij ons geplaatst. Zeer tevreden mee, komt afspraken na, denkt mee en werkt netjes."
    },
    {
      author: "namelesssnitchy",
      subtitle: "",
      text: "Met de hete zomers van afgelopen jaren toch maar besloten om een airco te laten zetten om wat beter te kunnen gaan slapen. Spiro gevonden via een maat en het klikte. Bleek veel kennis van zaken te hebben. En heeft ons goed en op tijd geholpen. Nou laat die volgende zomer maar komen hoor 😎"
    },
    {
      author: "Victor Beffers",
      subtitle: "3 maanden geleden",
      text: "Onderhoud aan mijn panasonic airco leidde meteen tot betere werking. Vriendelijke gast en je merkt aan alles dat hij weet wat ie doet. Yopper!"
    },
    {
      author: "Diederik Folkers",
      subtitle: "",
      text: "Top gozer! Duidelijk en betrouwbaar. Wist mij van advies te voorzien voor warmtepompen, zonnepanelen, airco units en vloerverwarmingen. Daardoor kon ik een weloverwogen beslissing maken."
    },
    {
      author: "Benas Blinstrubas",
      subtitle: "4 maanden geleden",
      text: "Spiro is een meester in zijn vak. Heel vriendelijk en een geweldige monteur!"
    }
  ];

  return (
    <div className="flex flex-col w-full">
      <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden">
        <div className="absolute inset-0 z-0 bg-white overflow-hidden">
          <div
            className="absolute inset-0 w-full h-full bg-cover bg-[80%_center] md:bg-center bg-no-repeat"
            style={{
              backgroundImage: "url('https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1024,h=777,fit=crop/A85E7zplBNSW667B/img_20240703_084711_165-mjEqjNqeDPs9v0pJ.jpg')"
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/80 to-transparent z-20" />
        </div>

        <div className="container mx-auto px-4 relative z-30">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-2xl"
          >
            <div className="mb-6 inline-flex items-center gap-3 rounded-full bg-white/92 px-4 py-2 shadow-lg ring-1 ring-orange-200 backdrop-blur-sm">
              <div className="rounded-full bg-gradient-to-br from-slate-950 via-slate-900 to-orange-950 p-1 shadow-md ring-1 ring-orange-300/40">
                <img src={logoUrl} alt="SpiroTechniek beeldmerk" className="h-10 w-10 object-contain" />
              </div>
              <span className="text-sm font-semibold uppercase tracking-[0.2em] text-gray-700">SpiroTechniek</span>
            </div>

            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 leading-tight mb-6">
              Climate Control Specialist in <span className="text-orange-600">Midden Nederland</span>
            </h1>
            <p className="text-xl text-gray-800 font-medium mb-8 leading-relaxed max-w-lg">
              Binnen 48 uur een vrijblijvende offerte. Installatie, onderhoud en advies voor woningen en bedrijven.
            </p>

            <div className="flex flex-col gap-5 mb-8 max-w-md">
              <Button
                size="lg"
                asChild
                className="relative overflow-hidden bg-gradient-to-b from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white font-bold text-xl px-8 py-8 h-auto shadow-[0_0_30px_rgba(16,185,129,0.3),inset_0_2px_0_rgba(255,255,255,0.3)] border border-emerald-600 rounded-xl hover:scale-[1.02] transition-all duration-300 w-full flex items-center justify-center group"
              >
                <a href="tel:+31658850981">
                  <Phone className="mr-3 h-6 w-6" />
                  Bel direct: 06 58850981
                  <span className="absolute top-0 -left-[100%] w-[50%] h-full bg-gradient-to-r from-transparent via-white/50 to-transparent skew-x-[-20deg] animate-shimmer pointer-events-none" />
                </a>
              </Button>

              <Button
                size="lg"
                asChild
                className="relative overflow-hidden bg-gradient-to-b from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold text-xl px-8 py-8 h-auto shadow-[0_0_30px_rgba(234,88,12,0.3),inset_0_2px_0_rgba(255,255,255,0.3)] border border-orange-600 rounded-xl hover:scale-[1.02] transition-all duration-300 w-full flex items-center justify-center group"
              >
                <Link to="/offerte">
                  Vraag gratis offerte aan
                  <span className="absolute top-0 -left-[100%] w-[50%] h-full bg-gradient-to-r from-transparent via-white/50 to-transparent skew-x-[-20deg] animate-shimmer pointer-events-none[animation-delay:1s]" />
                </Link>
              </Button>
            </div>

            <div className="flex">
              <Button variant="link" asChild className="text-gray-700 hover:text-orange-600 px-0 text-lg font-medium">
                <Link to="/diensten">Of bekijk eerst onze diensten <ArrowRight className="ml-2 h-5 w-5" /></Link>
              </Button>
            </div>
          </motion.div>
        </div>
      </section>

      <div className="bg-white border-y border-gray-100 py-10">
        <div className="container mx-auto px-4">
          <p className="text-center text-sm text-gray-500 mb-6 uppercase tracking-widest">Wij werken met premium merken</p>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-500">
            <span className="text-2xl font-black text-gray-800">DAIKIN</span>
            <span className="text-2xl font-black text-gray-800">MITSUBISHI</span>
            <span className="text-2xl font-black text-gray-800">Panasonic</span>
            <span className="text-2xl font-black text-gray-800">LG</span>
            <span className="text-2xl font-black text-gray-800">SINCLAIR</span>
          </div>
        </div>
      </div>

      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl font-bold mb-4">Alles voor een duurzaam en comfortabel huis</h2>
            <p className="text-gray-600">Van verkoeling in de zomer tot duurzame verwarming in de winter.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <ServiceCard
              href="/diensten/airco"
              icon={<Wind className="h-8 w-8 text-orange-600" />}
              title="Airco"
              desc="Verkoelen én verwarmen. Energiezuinige split-units en multi-split systemen."
              price="v.a. €1499,-"
            />
            <ServiceCard
              href="/diensten/warmtepomp"
              icon={<Thermometer className="h-8 w-8 text-orange-600" />}
              title="Warmtepomp"
              desc="Stap van het gas af. Hybride en all-electric oplossingen voor uw woning."
              price="v.a. €3249,-"
            />
            <ServiceCard
              href="/diensten/zonnepanelen-elektra"
              icon={<Zap className="h-8 w-8 text-orange-600" />}
              title="Zonnepanelen & Elektra"
              desc="Eigen stroom opwekken, groepenkast vernieuwen en laadpalen installeren."
              price="v.a. €1499,-"
            />
            <ServiceCard
              href="/diensten/cv-sanitair"
              icon={<Droplet className="h-8 w-8 text-orange-600" />}
              title="CV & Vloerverwarming"
              desc="Installatie en onderhoud van CV-ketels, vloerverwarming en loodgieterswerk."
              price="v.a. €1799,-"
            />
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold mb-4">Zo werken wij</h2>
            <p className="text-gray-600">Eerlijk, duidelijk en zonder verrassingen achteraf.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
            <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-orange-100 -z-10" />

            <ProcessStep
              number="1"
              title="Gratis Advies"
              desc="We komen bij u langs of bespreken telefonisch uw wensen en de situatie."
            />
            <ProcessStep
              number="2"
              title="Offerte binnen 48u"
              desc="U ontvangt een scherpe, vrijblijvende offerte zonder kleine lettertjes."
            />
            <ProcessStep
              number="3"
              title="Vakkundige Installatie"
              desc="Onze gecertificeerde monteurs installeren alles netjes en leggen de werking uit."
            />
          </div>

          <div className="mt-12 text-center">
            <Button size="lg" asChild className="bg-gray-900 hover:bg-gray-800 text-white font-semibold">
              <Link to="/offerte">Start met stap 1</Link>
            </Button>
          </div>
        </div>
      </section>

      <AppointmentScheduler />

      <section className="py-20 bg-gradient-to-br from-orange-500 to-orange-700 text-white overflow-hidden relative">
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-orange-300 via-transparent to-transparent" />

        <div className="container mx-auto px-4 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
            <div className="lg:col-span-8">
              <div className="inline-flex items-center gap-3 px-4 py-2 bg-white/20 rounded-full text-white text-sm font-semibold mb-4 backdrop-blur-sm">
                <div className="rounded-full bg-gradient-to-br from-slate-950 via-slate-900 to-black p-1 ring-1 ring-orange-200/40">
                  <img src={logoUrl} alt="SpiroTechniek icoon" className="h-8 w-8 object-contain" />
                </div>
                <span>Kracht & Beheersing</span>
              </div>
              <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight">
                Waarom kiezen voor <br />SpiroTechniek?
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8">
                <ValueItem
                  title="Duurzaam by design"
                  desc="Wij letten nauw op de meest duurzame keuze voor een gezonde, veilige en toekomstbestendige woning."
                />
                <ValueItem
                  title="Koning in kwaliteit"
                  desc="Wij vinden de materialen en producten voor u met de allerbeste prijs-kwaliteitverhouding."
                />
                <ValueItem
                  title="Integriteit"
                  desc="Eerlijke prijzen en beloftes nakomen. Wij beschikken over een specialist in integriteit en ethiek."
                />
                <ValueItem
                  title="Totaal Thuis"
                  desc="Met onze installatietechniek en creatieve monteurs voorzien wij uw héle huis van slim comfort."
                />
                <ValueItem
                  title="Zorgzaam & Nighttime Knight"
                  desc="Wij zorgen voor u en de installatie. Inclusief spoedservice voor kwetsbaren en nachtservice bij storingen."
                />
                <ValueItem
                  title="Lokale Legende"
                  desc="Altijd dichtbij vanuit Lelystad en Blaricum. Bij ons is de klant nog écht koning in klantgerichtheid."
                />
              </div>
            </div>
            <div className="lg:col-span-4 relative hidden lg:flex justify-center">
              <div className="absolute inset-6 bg-white/10 rounded-3xl blur-2xl" />
              <div className="relative rounded-3xl bg-white/10 backdrop-blur-sm border border-white/20 p-6 shadow-2xl">
                <img
                  src={logoUrl}
                  alt="SpiroTechniek tijgerlogo"
                  className="w-[26rem] h-[26rem] xl:w-[32rem] xl:h-[32rem] object-contain"
                />
              </div>

              <div className="absolute -bottom-6 -left-2 bg-white text-gray-900 p-6 rounded-lg shadow-xl max-w-xs border-l-4 border-orange-600">
                <div className="flex items-center gap-3 mb-2">
                  <ShieldCheck className="h-8 w-8 text-orange-600" />
                  <span className="font-bold text-lg">Gecertificeerd</span>
                </div>
                <p className="text-sm text-gray-600">Climate Control Specialist, Elektricien & Loodgieter in één.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50 overflow-hidden">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-4">Wat zeggen onze klanten?</h2>
          <div className="flex justify-center items-center gap-2 mb-12">
            <span className="font-bold text-lg">4.9</span>
            <div className="flex">
              {[1, 2, 3, 4, 5].map((i) => <Star key={i} className="h-5 w-5 text-orange-500 fill-orange-500" />)}
            </div>
            <span className="text-gray-500 text-sm ml-2">(Google Reviews)</span>
          </div>

          <Carousel
            opts={{
              align: "start",
              loop: true
            }}
            className="w-full max-w-6xl mx-auto"
          >
            <CarouselContent className="-ml-4">
              {reviews.map((review, idx) => (
                <CarouselItem key={idx} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <TestimonialCard
                    text={review.text}
                    author={review.author}
                    subtitle={review.subtitle}
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex justify-center gap-4 mt-8">
              <CarouselPrevious className="relative inset-0 translate-y-0 h-12 w-12 border-orange-200 text-orange-600 hover:bg-orange-50 hover:text-orange-700" />
              <CarouselNext className="relative inset-0 translate-y-0 h-12 w-12 border-orange-200 text-orange-600 hover:bg-orange-50 hover:text-orange-700" />
            </div>
          </Carousel>

          <div className="mt-12 text-center">
            <Button variant="outline" size="lg" asChild className="rounded-full border-gray-300 hover:bg-gray-100 text-gray-700 font-medium px-8 shadow-sm transition-all hover:scale-105">
              <a href="https://www.google.com/maps/place/Spiro+Techniek+B.V./@52.2907,5.279243,17z/data=!4m8!3m7!1s0x47c665000334a2c5:0x357cce65137da13f!8m2!3d52.2907!4d5.2818179!9m1!1b1!16s%2Fg%2F11ydkzl4kg?entry=ttu&g_ep=EgoyMDI2MDIyMi4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                👉 Bekijk alle reviews op Google
              </a>
            </Button>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-4xl mx-auto bg-gray-900 rounded-3xl p-8 md:p-16 text-white shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-orange-600/20 rounded-full blur-3xl -mr-16 -mt-16" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-600/20 rounded-full blur-3xl -ml-16 -mb-16" />

            <h2 className="text-3xl md:text-5xl font-bold mb-6 relative z-10">Klaar voor meer comfort?</h2>
            <p className="text-gray-300 text-lg mb-10 relative z-10">Laat uw gegevens achter. Wij nemen binnen 1 werkdag contact op voor een afspraak.</p>

            <div className="w-full aspect-video rounded-xl overflow-hidden mb-10 relative z-10 shadow-2xl border border-white/10">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/Ytz3MDRVsSo"
                title="SpiroTechniek Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>

            <Button size="lg" asChild className="bg-orange-600 hover:bg-orange-700 text-white text-lg px-10 py-7 h-auto shadow-lg relative z-10">
              <Link to="/offerte">Vraag offerte aan <ArrowRight className="ml-2 h-5 w-5" /></Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

const ServiceCard = ({ icon, title, desc, price, href }: { icon: React.ReactNode, title: string, desc: string, price: string, href: string }) => (
  <Link to={href} className="block h-full">
    <Card className="border-none shadow-md hover:shadow-xl transition-shadow duration-300 h-full cursor-pointer">
      <CardContent className="p-6 flex flex-col h-full">
        <div className="mb-4 bg-orange-50 w-16 h-16 rounded-2xl flex items-center justify-center">
          {icon}
        </div>
        <h3 className="text-xl font-bold mb-2 group-hover:text-orange-600 transition-colors">{title}</h3>
        <p className="text-gray-600 text-sm mb-4 flex-grow">{desc}</p>
        <div className="mt-auto pt-4 border-t border-gray-100 flex items-center justify-between">
          <span className="font-bold text-orange-600">{price}</span>
          <div className="bg-orange-50 p-2 rounded-full">
            <ArrowRight className="h-4 w-4 text-orange-600" />
          </div>
        </div>
      </CardContent>
    </Card>
  </Link>
);

const ProcessStep = ({ number, title, desc }: { number: string, title: string, desc: string }) => (
  <div className="flex flex-col items-center text-center relative z-10">
    <div className="w-12 h-12 bg-white border-2 border-orange-600 text-orange-600 rounded-full flex items-center justify-center text-xl font-bold mb-6 shadow-sm">
      {number}
    </div>
    <h3 className="text-xl font-bold mb-2">{title}</h3>
    <p className="text-gray-600 max-w-xs">{desc}</p>
  </div>
);

const ValueItem = ({ title, desc }: { title: string, desc: string }) => (
  <div className="flex items-start gap-4">
    <CheckCircle2 className="h-6 w-6 text-orange-200 mt-1 shrink-0" />
    <div>
      <h3 className="font-bold text-lg mb-1">{title}</h3>
      <p className="text-orange-50/90 leading-relaxed text-sm">{desc}</p>
    </div>
  </div>
);

const TestimonialCard = ({ text, author, subtitle }: { text: string, author: string, subtitle?: string }) => (
  <Card className="bg-white border-gray-100 h-full flex flex-col">
    <CardContent className="p-8 flex flex-col flex-grow">
      <div className="flex gap-1 mb-4">
        {[1, 2, 3, 4, 5].map((i) => <Star key={i} className="h-4 w-4 text-orange-500 fill-orange-500" />)}
      </div>
      <p className="text-gray-700 italic mb-6 flex-grow">"{text}"</p>
      <div className="mt-auto">
        <p className="font-bold text-gray-900">{author}</p>
        {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
      </div>
    </CardContent>
  </Card>
);

export default Home;
